import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IComponent) {
    (function(LoadingState) {
        LoadingState["LOADING_STATE_UNKNOWN"] = "LOADING_STATE_UNKNOWN";
        LoadingState["LOADED"] = "LOADED";
        LoadingState["PENDING"] = "PENDING";
    })(IComponent.LoadingState || (IComponent.LoadingState = {}));
    (function(IComponentStyle) {
        IComponentStyle.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IComponent.IComponentStyle || (IComponent.IComponentStyle = {}));
    IComponent.build = function(partial) {
        return _object_spread({
            on_view: [],
            viewports: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IComponent || (IComponent = {}));
export var IComponent;
